export const demoFinetunesPath = "/lens";

export function getDemoFinetuneHref(slug: string): string {
  return `${demoFinetunesPath}/${slug}`;
}
